/* eslint-disable no-console,react/jsx-props-no-spreading */
/**
 * This error page is used by our custom server
 */
import React from 'react';
import PropTypes from 'prop-types';
import withWP from 'utils/withWP';
import withUA from 'utils/withUA';
import initialRenderError from 'utils/initialRenderError';
import { wrapper } from 'root/state';
import Error from '../components/Error';

function Err({ statusCode, offline, wpLoggedIn, ...props }) {
  return (
    <Error
      statusCode={statusCode}
      offline={offline}
      wpLoggedIn={wpLoggedIn}
      {...props}
    />
  );
}

export const getServerSideProps = withUA(
  withWP(
    wrapper.getServerSideProps(async ({ res, err, store, req, query }) => {
      const initialProps = await initialRenderError(res, req, err, query, store);
      return { props: initialProps };
    })
  )
);

Err.propTypes = {
  statusCode: PropTypes.number,
  offline: PropTypes.bool,
  wpLoggedIn: PropTypes.bool,
};

export default Err;
